import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import companiesSlice from '../reducers/companies.slice'

const persistConfig = {
  key: 'companiesSlice',
  storage,
}

export const persistedCompaniesReducer = persistReducer(persistConfig, companiesSlice)